import { render, staticRenderFns } from "./CoachProfile.vue?vue&type=template&id=3887250e&scoped=true&"
import script from "./CoachProfile.vue?vue&type=script&lang=js&"
export * from "./CoachProfile.vue?vue&type=script&lang=js&"
import style0 from "./CoachProfile.vue?vue&type=style&index=0&id=3887250e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3887250e",
  null
  
)

export default component.exports